import script from "./KBreadcrumbs.vue?vue&type=script&setup=true&lang=ts"
export * from "./KBreadcrumbs.vue?vue&type=script&setup=true&lang=ts"

import "./KBreadcrumbs.vue?vue&type=style&index=0&id=57162837&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57162837"]])

export default __exports__